document.addEventListener("DOMContentLoaded", function () {
  // Initialize all hero carousels on the page
  const heroCarousels = document.querySelectorAll(".hero-carousel");

  heroCarousels.forEach((carousel) => {
    initializeHeroCarousel(carousel);
  });
});

function initializeHeroCarousel(carouselElement) {
  const swiperContainer = carouselElement.querySelector(".hero-swiper");
  const navigationCards = carouselElement.querySelectorAll(
    ".swiper-pagination-card",
  );
  const mobileProgressFill = carouselElement.querySelector(
    ".hero-carousel__progress-fill",
  );

  if (!swiperContainer || navigationCards.length === 0) {
    console.warn("Hero carousel: Missing required elements");
    return;
  }

  // Declare variables at top of function scope
  let heroSwiper;
  let spacingUpdatePending = false;
  let heightUpdatePending = false;

  // Initialize Swiper
  heroSwiper = new Swiper(swiperContainer, {
    // Core settings
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    speed: 600,
    autoHeight: false, // Prevent auto height adjustment

    // Auto-play
    autoplay: {
      delay: 6000, // Back to normal autoplay timing
      disableOnInteraction: false,
      pauseOnMouseEnter: false,
    },

    // Store autoplay delay for progress bar timing
    autoplayDelay: 6000,

    // Effects
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },

    // Accessibility
    a11y: {
      enabled: true,
      prevSlideMessage: "Previous slide",
      nextSlideMessage: "Next slide",
    },

    // Keyboard control
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },

    // Touch/mouse drag
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,

    // Events
    on: {
      init: function () {
        updateNavigationCards(0);
        // Hide all content first, then initialize first slide
        hideAllSlideContent();
        // Initialize first slide
        initSlideContent();
        // Start progress bars for current slide immediately
        startProgressBar(0);
        startMobileProgressBar(0);
        // Ensure equal slide heights
        equalizeSlideHeights();
      },
      slideChangeTransitionStart: function () {
        // Update navigation cards immediately when transition starts
        updateNavigationCards(this.activeIndex);
        // Don't hide content immediately - let it fade with the slide
        // Reset previous progress bars first, then start new one immediately
        resetPreviousProgressBars(this.activeIndex);
        startProgressBar(this.activeIndex);
        startMobileProgressBar(this.activeIndex);
      },
      slideChangeTransitionEnd: function () {
        // Hide all content first, then show active content with proper timing
        hideAllSlideContent();
        setTimeout(() => {
          showActiveSlideContent();
        }, 0);
        // Reset previous progress bars (but not current one)
        resetPreviousProgressBars(this.activeIndex);
      },
      autoplayPause: function () {
        // Pause progress bar animations
        pauseProgressBars();
        pauseMobileProgressBar();
      },
      autoplayResume: function () {
        // Resume progress bar animations
        resumeProgressBars();
        resumeMobileProgressBar();
      },
    },
  });

  // Navigation cards click handlers
  navigationCards.forEach((card, index) => {
    card.addEventListener("click", () => {
      heroSwiper.slideTo(index);
      // Don't manually start progress bar here - let the slideChangeTransitionEnd event handle it
    });
  });

  // Update active navigation card
  function updateNavigationCards(activeIndex) {
    const lastIndex = navigationCards.length - 1;

    navigationCards.forEach((card, index) => {
      const isSpotlight = index === lastIndex;
      const isActive = index === activeIndex;

      // Remove all state classes first
      card.classList.remove(
        "hero-carousel__card--active",
        "hero-carousel__card--spotlight",
        "hero-carousel__card--progress",
      );

      if (isSpotlight) {
        // Last item always gets spotlight styling
        card.classList.add("hero-carousel__card--spotlight");
      }

      // Set proper ARIA attributes for tab role
      card.setAttribute("role", "tab");
      card.setAttribute("aria-selected", isActive.toString());
      // Remove aria-pressed as it's not valid for tab role
      card.removeAttribute("aria-pressed");

      if (isActive) {
        card.setAttribute("aria-label", `Slide ${index + 1} active`);
      } else {
        card.setAttribute("aria-label", `Go to slide ${index + 1}`);
      }
    });
  }

  // Initialize first slide content
  function initSlideContent() {
    const firstSlide = carouselElement.querySelector(
      ".swiper-slide:first-child",
    );
    if (firstSlide) {
      const content = firstSlide.querySelector(
        ".hero-carousel__content[data-aos]",
      );
      if (content) {
        // Ensure smooth transitions are set up
        content.style.transition = "opacity 0.5s ease, transform 0.5s ease";

        setTimeout(() => {
          content.classList.add("aos-animate");
          content.style.opacity = "1";
          content.style.transform = "translateY(0)";
        }, 50);
      }
    }
  }

  // Hide all slide content smoothly
  function hideAllSlideContent() {
    const allContent = carouselElement.querySelectorAll(
      ".hero-carousel__content[data-aos]",
    );
    allContent.forEach((content) => {
      content.classList.remove("aos-animate");
      // Ensure smooth transitions are set up
      content.style.transition = "opacity 0.5s ease, transform 0.5s ease";
      // Add smooth reset for better transitions
      content.style.opacity = "0";
      content.style.transform = "translateY(20px)";
    });
  }

  // Show active slide content with smooth animation
  function showActiveSlideContent() {
    const activeSlide = carouselElement.querySelector(".swiper-slide-active");
    if (activeSlide) {
      const content = activeSlide.querySelector(
        ".hero-carousel__content[data-aos]",
      );
      if (content) {
        // Ensure smooth transitions
        content.style.transition = "opacity 0.5s ease, transform 0.5s ease";

        // Trigger smooth animation with reduced delay
        setTimeout(() => {
          content.classList.add("aos-animate");
          content.style.opacity = "1";
          content.style.transform = "translateY(0)";
        }, 0);
      }
    }
  }

  // Progress bars are controlled by Swiper's autoplay events only

  // No manual hover handlers needed - Swiper calls autoplayPause/autoplayResume events

  // Handle visibility change (pause when tab is not active)
  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      heroSwiper.autoplay.pause();
      pauseProgressBars();
    } else {
      heroSwiper.autoplay.resume();
      resumeProgressBars();
    }
  });

  // Progress bar management functions
  function startProgressBar(activeIndex) {
    const lastIndex = navigationCards.length - 1;
    if (activeIndex !== lastIndex) {
      const activeCard = navigationCards[activeIndex];
      if (activeCard) {
        activeCard.classList.add("hero-carousel__card--progress");
        // Progress animation should complete AS the slide transition starts
        const totalDuration = 6500;
        activeCard.style.setProperty(
          "--progress-duration",
          `${totalDuration}ms`,
        );
      }
    }
  }

  function resetProgressBars() {
    navigationCards.forEach((card) => {
      card.classList.remove("hero-carousel__card--progress");
      card.style.removeProperty("--progress-duration");
      card.style.removeProperty("--progress-state");
    });
  }

  function resetPreviousProgressBars(activeIndex) {
    navigationCards.forEach((card, index) => {
      if (index !== activeIndex) {
        card.classList.remove("hero-carousel__card--progress");
        card.style.removeProperty("--progress-duration");
        card.style.removeProperty("--progress-state");
      }
    });
  }

  function pauseProgressBars() {
    if (!heroSwiper) return;
    const activeCard = navigationCards[heroSwiper.activeIndex];
    const lastIndex = navigationCards.length - 1;
    if (activeCard && heroSwiper.activeIndex !== lastIndex) {
      activeCard.style.setProperty("--progress-state", "paused");
    }
  }

  function resumeProgressBars() {
    if (!heroSwiper) return;
    const activeCard = navigationCards[heroSwiper.activeIndex];
    const lastIndex = navigationCards.length - 1;
    if (activeCard && heroSwiper.activeIndex !== lastIndex) {
      activeCard.style.setProperty("--progress-state", "running");
    }
  }

  // Dynamic padding/margin adjustments for hero-carousel__inner and hero-carousel__cards

  function adjustCarouselSpacing() {
    if (spacingUpdatePending) return;
    spacingUpdatePending = true;

    requestAnimationFrame(() => {
      // Only run on desktop (screen width > 992px)
      if (window.innerWidth <= 992) {
        // Reset styles on mobile
        const innerContainer = carouselElement.querySelector(
          ".hero-carousel__inner",
        );
        const heroNavigation = carouselElement.querySelector(
          ".hero-carousel__navigation",
        );

        if (innerContainer) {
          innerContainer.style.paddingBottom = "";
        }
        if (heroNavigation) {
          heroNavigation.style.marginTop = "";
        }
        spacingUpdatePending = false;
        return;
      }

      const cardsContainer = carouselElement.querySelector(
        ".hero-carousel__cards",
      );
      const innerContainer = carouselElement.querySelector(
        ".hero-carousel__inner",
      );
      const heroNavigation = carouselElement.querySelector(
        ".hero-carousel__navigation",
      );

      if (cardsContainer && innerContainer) {
        // Batch DOM read
        const cardsHeight = cardsContainer.offsetHeight;

        // Batch DOM writes
        innerContainer.style.paddingBottom = `calc(${cardsHeight}px + 2rem)`;
        heroNavigation.style.marginTop = `calc(-${cardsHeight}px + 1px)`;
      }

      spacingUpdatePending = false;
    });
  }

  // Call on initialization
  setTimeout(() => {
    adjustCarouselSpacing();
  }, 100);

  // Equal height function - batched DOM operations

  function equalizeSlideHeights() {
    if (heightUpdatePending) return;
    heightUpdatePending = true;

    requestAnimationFrame(() => {
      const slides = carouselElement.querySelectorAll(".swiper-slide");
      if (slides.length === 0) {
        heightUpdatePending = false;
        return;
      }

      // Batch DOM writes - reset heights first
      slides.forEach((slide) => {
        slide.style.height = "auto";
      });

      // Batch DOM reads after next paint
      requestAnimationFrame(() => {
        let maxHeight = 0;
        slides.forEach((slide) => {
          const slideHeight = slide.offsetHeight;
          if (slideHeight > maxHeight) {
            maxHeight = slideHeight;
          }
        });

        // Batch DOM writes - apply max height
        slides.forEach((slide) => {
          slide.style.height = `${maxHeight}px`;
        });

        heightUpdatePending = false;
      });
    });
  }

  // Mobile progress bar functions
  function startMobileProgressBar(activeIndex) {
    if (!mobileProgressFill) return;

    // Force complete reset - remove animation and set width to 0
    mobileProgressFill.classList.remove(
      "hero-carousel__progress-fill--animating",
    );
    mobileProgressFill.style.removeProperty("--progress-duration");
    mobileProgressFill.style.removeProperty("--progress-state");
    mobileProgressFill.style.width = "0%";
    mobileProgressFill.style.transition = "none";

    // Force a reflow to ensure the reset takes effect
    mobileProgressFill.offsetHeight;

    // Always animate mobile progress bar for ALL slides (unlike desktop which skips last slide)
    const totalDuration = 6500; // Match desktop timing

    // Start fresh animation after ensuring reset
    setTimeout(() => {
      mobileProgressFill.style.transition = ""; // Remove transition override
      mobileProgressFill.classList.add(
        "hero-carousel__progress-fill--animating",
      );
      mobileProgressFill.style.setProperty(
        "--progress-duration",
        `${totalDuration}ms`,
      );
      mobileProgressFill.style.setProperty("--progress-state", "running");
    }, 100); // Slightly longer delay for better reset
  }

  function pauseMobileProgressBar() {
    if (!mobileProgressFill) return;
    // Pause animation
    mobileProgressFill.style.setProperty("--progress-state", "paused");
  }

  function resumeMobileProgressBar() {
    if (!mobileProgressFill) return;
    // Resume animation
    mobileProgressFill.style.setProperty("--progress-state", "running");
  }

  // Call on window resize
  window.addEventListener("resize", () => {
    adjustCarouselSpacing();
    equalizeSlideHeights();
  });

  // Return swiper instance for external control if needed
  return heroSwiper;
}
